import React, { useEffect } from "react";
import { Box, Typography, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";

const ThankYou = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // ✅ Google Ads Conversion Tracking
    if (window.gtag) {
      window.gtag("event", "conversion", {
        send_to: "AW-16777025590/yY3LCObr6_EbELaw9L8-",
        value: 500.0,
        currency: "INR",
      });
    } else {
      console.warn("gtag not found — ensure it's loaded in index.html");
    }
  }, []);

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        px: 2,
      }}
    >
      <Typography variant="h4" fontWeight="bold" color="green" gutterBottom>
        Thank You!
      </Typography>
      <Typography variant="body1" gutterBottom>
        Your submission has been received.
      </Typography>
      <Button
        variant="contained"
        sx={{
          mt: 2,
          bgcolor: "green",
          "&:hover": { bgcolor: "darkgreen" },
        }}
        onClick={() => navigate("/")}
      >
        Back to Home
      </Button>
    </Box>
  );
};

export default ThankYou;
